var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { C as ComponentCategory, E as EntityType } from "../../enums-86f58524.js";
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import { spatialMap } from "../../utils/Collision.js";
import "../types.js";
import { S as SpatialMapSchema } from "../../SpatialMap-56228ece.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
import "../../Locomotion-379972de.js";
import "../../Radius-89a665f8.js";
import "../../Transform-9450b7b5.js";
import "../../Collisions-9e9492fb.js";
import "../../utils/vector.js";
const SPATIAL_MAP_CELL_SIZE = 100;
class SpatialMapSystem {
  constructor() {
    __publicField(this, "type", "SpatialMap");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", SpatialMapSchema);
    __publicField(this, "depth", DEPTHS.COLLISION - 1e-6);
  }
  run(entity, gameModel) {
    const spatialMapData = gameModel.getTypedUnsafe(entity, SpatialMapSchema);
    spatialMapData.pointSets = {};
    spatialMapData.spatialMap = spatialMap(
      gameModel,
      gameModel.getComponentActives("Transform"),
      SPATIAL_MAP_CELL_SIZE,
      spatialMapData.pointSets
    );
    spatialMapData[EntityType.INTERACTABLE] = spatialMap(
      gameModel,
      gameModel.getComponentActives("InteractableType"),
      SPATIAL_MAP_CELL_SIZE,
      spatialMapData.pointSets
    );
    spatialMapData[EntityType.ENEMY] = spatialMap(
      gameModel,
      gameModel.getComponentActives("EnemyType"),
      SPATIAL_MAP_CELL_SIZE,
      spatialMapData.pointSets
    );
    spatialMapData[EntityType.PICKUP] = spatialMap(
      gameModel,
      gameModel.getComponentActives("PickupType"),
      SPATIAL_MAP_CELL_SIZE,
      spatialMapData.pointSets
    );
    spatialMapData[EntityType.ALLY] = spatialMap(
      gameModel,
      gameModel.getComponentActives("PlayerType"),
      SPATIAL_MAP_CELL_SIZE,
      spatialMapData.pointSets
    );
    spatialMapData[EntityType.PROJECTILE] = spatialMap(
      gameModel,
      gameModel.getComponentActives("ProjectileType"),
      SPATIAL_MAP_CELL_SIZE,
      spatialMapData.pointSets
    );
    spatialMapData[EntityType.WALL] = spatialMap(
      gameModel,
      gameModel.getComponentActives("WallType"),
      SPATIAL_MAP_CELL_SIZE,
      spatialMapData.pointSets
    );
    spatialMapData[EntityType.WEAPON] = spatialMap(
      gameModel,
      gameModel.getComponentActives("WeaponType"),
      SPATIAL_MAP_CELL_SIZE,
      spatialMapData.pointSets
    );
  }
}
registerSystem(SpatialMapSystem);
export {
  SPATIAL_MAP_CELL_SIZE
};
//# sourceMappingURL=SpatialMap.js.map
